'use client';

import { c as _c } from "react/compiler-runtime";
import { ControlBarReportAction } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarActions';
import type { ControlBarViewportLayoutProps } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarViewportLayout';
import Full3dExitButton from '@/app/[locale]/(worlds)/[roomId]/components/Full3dExitButton';
import { KIDS_MODE_WORLD_REPORT_VARIANT } from '@/constants/report';
import { useUAContext } from '@/context/UAContext';
export function KidsModeControlBar(t0) {
  const $ = _c(11);
  const {
    popupContainer
  } = t0;
  const {
    isMobileLandscape
  } = useUAContext();
  const t1 = isMobileLandscape ? "landscape" : "portrait";
  const t2 = isMobileLandscape ? "z-floating bg-vive-primary-80/80 flex h-full w-[60px] shrink-0 flex-col justify-between pt-1 pr-2 pb-[max(4px,env(safe-area-inset-bottom))] pl-7 backdrop-blur-2xl" : "z-floating bg-vive-primary-80/80 flex h-[34px] w-full shrink-0 items-center justify-between px-9 py-1 backdrop-blur-2xl";
  const t3 = `${isMobileLandscape ? "-rotate-90" : ""} size-3.5 text-vive-primary-20`;
  let t4;
  if ($[0] !== popupContainer || $[1] !== t3) {
    t4 = <div className="shrink-0"><Full3dExitButton className="z-floating relative" buttonClassName="flex size-6 shrink-0 items-center justify-center rounded-full bg-white/15 p-1 backdrop-blur-[50px]" dialogContainer={popupContainer} dialogPresentation="mobile-control-bar" iconClassName={t3} /></div>;
    $[0] = popupContainer;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `${isMobileLandscape ? "-rotate-90" : ""} size-4 shrink-0 text-vive-primary-20`;
  let t6;
  if ($[3] !== popupContainer || $[4] !== t5) {
    t6 = <ControlBarReportAction className="flex size-6 shrink-0 items-center justify-center rounded-full bg-white/15 p-1 backdrop-blur-[50px]" iconClassName={t5} popupContainer={popupContainer} reportModalContainer={popupContainer} reportVariant={KIDS_MODE_WORLD_REPORT_VARIANT} />;
    $[3] = popupContainer;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4 || $[9] !== t6) {
    t7 = <div data-component="kids-mode-control-bar" data-orientation={t1} className={t2}>{t4}{t6}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
export function createKidsModeControlBarViewportLayout(isMobileLandscape: boolean): Omit<ControlBarViewportLayoutProps, 'children'> {
  return {
    barPlacement: 'before',
    className: isMobileLandscape ? 'flex h-full min-h-0 min-w-0 flex-1 flex-row' : 'flex h-full min-h-0 min-w-0 flex-1 flex-col',
    dataComponent: 'mobile-control-bar-layout',
    dataOrientation: isMobileLandscape ? 'landscape' : 'portrait',
    renderControlBar: popupContainer => <KidsModeControlBar popupContainer={popupContainer} />,
    viewportDataComponent: 'mobile-control-bar-viewport'
  };
}